import { Link } from 'react-router-dom';
import { heroBanners } from '@/mocks/videos';
import { useState, useEffect, useCallback } from 'react';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const total = heroBanners.length;

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % total);
  }, [total]);

  const prev = useCallback(() => {
    setCurrent((p) => (p - 1 + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const banner = heroBanners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={banner.bgImage}
          alt={banner.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-3 md:mb-4 leading-tight">
          {banner.title}
        </h2>
        <p className="text-sm md:text-lg text-white/80 mb-6 md:mb-8 max-w-2xl">
          {banner.subtitle}
        </p>
        <div className="flex items-center gap-4">
          <Link
            to={`/article/${banner.videoId}`}
            className="px-6 md:px-8 py-3 bg-primary-500 text-white rounded-full text-sm md:text-base font-medium hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观看
          </Link>
          <Link
            to={`/article/${banner.videoId}`}
            className="px-6 md:px-8 py-3 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm md:text-base font-medium hover:bg-white/30 transition-all whitespace-nowrap"
          >
            了解详情
          </Link>
        </div>

        <div className="flex items-center gap-2 mt-8 md:mt-12">
          {heroBanners.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`w-2 h-2 md:w-2.5 md:h-2.5 rounded-full transition-all cursor-pointer ${
                i === current ? 'bg-white w-6 md:w-8' : 'bg-white/40 hover:bg-white/70'
              }`}
              aria-label={`切换到第${i + 1}张`}
            />
          ))}
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 backdrop-blur-sm text-white transition-all cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 backdrop-blur-sm text-white transition-all cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>
    </section>
  );
}